import React, { PureComponent } from 'react'
import { Row, Col } from 'react-bootstrap'

class Tab4 extends PureComponent {
  render () {
    return (
      <Col sm={12}>
        <Row>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">V.S.B:</span>
              <span className="second">V.S.B</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Marca:</span>
              <span className="second">Marca</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Familia:</span>
              <span className="second">Familia</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Modelo:</span>
              <span className="second">Modelo</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Acabado:</span>
              <span className="second">Acabado</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Color:</span>
              <span className="second">Color</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Combustible:</span>
              <span className="second">Combustible</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Chasis:</span>
              <span className="second">Chasis</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Ubicación entrega:</span>
              <span className="second">Ubicación entrega</span>
            </div>
          </Col>
          <Col sm={3}>
            <div className="text-band">
              <span className="first">Fecha prevista entrega:</span>
              <span className="second">Fecha prevista entrega</span>
            </div>
          </Col>
        </Row>
      </Col>
    )
  }
}

export default Tab4
